$( document ).ready(function() {

  $(".product-dropdown-title").on("click", function() {
    var currentDropdown = $(this).closest(".product-dropdown"),
        currentText = currentDropdown.find(".product-dropdown-text");

    $(".product-dropdown .product-dropdown-text").not(currentText).slideUp();
    currentText.slideToggle();

    $(".product-dropdown").not(currentDropdown).removeClass('open');
    currentDropdown.toggleClass('open');
  });

  let productSwiper = null;
  function initOrDestroySwiper() {
    if (window.innerWidth <= 820) {
       if (!productSwiper) {
         productSwiper = new Swiper('#product-media-container', {
           speed: 500,
           loop: true,
           spaceBetween: 0,
           pagination: {
             el: ".swiper-pagination",
             type: "fraction",
           },
           navigation: {
             nextEl: ".swiper-button-next",
             prevEl: ".swiper-button-prev",
           },
           zoom: {
              maxRatio: 3, // zoom máximo 3x
              minRatio: 1, // zoom mínimo
            },
            simulateTouch: true,
            touchStartPreventDefault: false,
         });
      }
    } else {
      if (productSwiper) {
         productSwiper.destroy(true, true);
         productSwiper = null;
       }
     }
   }
   initOrDestroySwiper();
   window.addEventListener('resize', function() {
   initOrDestroySwiper();
   });

});
